export default "__VITE_ASSET__DV556L2C__"